import { render, staticRenderFns } from "./BaseTablePagination.vue?vue&type=template&id=4db922d2&scoped=true&"
import script from "./BaseTablePagination.vue?vue&type=script&lang=js&"
export * from "./BaseTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db922d2",
  null
  
)

export default component.exports